import { YMaps, Map, Placemark } from 'react-yandex-maps';
import { Location } from '../../../types/location';
interface YandexMapComponentProps {
    coordinates: number[]
}
export const YandexMapComponent = ({coordinates}: YandexMapComponentProps) => {
    const mapStyle = {
        width: '100%',
        height: '100%',
        minHeight: '400px' // Add minimum height to ensure visibility
    };
    return (
        <YMaps query={{lang: 'ru_RU'}}>
            <Map
                defaultState={{center: coordinates, zoom: 15}}
                style={mapStyle}
                >
            <Placemark 
                geometry={coordinates}
                options={{
                    iconColor: '#FF0000',
                    preset: 'islands#redDotIcon'
                }}
            />
            </Map>
        </YMaps>
    )
}